import { useEffect, useState } from "react";
import { fetchMyList, removeFromMyList } from "@/lib/api";
import ContentCard from "@/components/ContentCard";
import { Trash2 } from "lucide-react";
import { toast } from "sonner";

export default function MyList() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  const load = async () => {
    setLoading(true);
    try { setItems(await fetchMyList()); } finally { setLoading(false); }
  };
  useEffect(() => { load(); }, []);

  const remove = async (id) => {
    await removeFromMyList(id); toast.success("Removed from My List");
    setItems(items.filter(i => i.id !== id));
  };

  return (
    <div className="pt-16" data-testid="my-list-page">
      <div className="max-w-[1600px] mx-auto px-4 md:px-8 py-10">
        <p className="text-[#D4AF37] text-[11px] font-semibold tracking-[0.25em] uppercase mb-2">Saved for You</p>
        <h1 className="font-heading text-4xl md:text-6xl font-bold mb-10 leading-none">My List</h1>
        {loading ? <p className="text-white/50">Loading…</p> : items.length === 0 ? (
          <p className="text-white/60" data-testid="empty-list">Your list is empty. Bookmark shows and sermons from any content page.</p>
        ) : (
          <div className="flex flex-wrap gap-4">
            {items.map(it => (
              <div key={it.id} className="relative">
                <ContentCard item={it} />
                <button onClick={() => remove(it.id)} className="absolute top-2 right-2 w-9 h-9 rounded-full bg-black/70 hover:bg-[#E11D48] flex items-center justify-center border border-white/20 z-10" data-testid={`remove-${it.id}`}><Trash2 className="w-4 h-4" /></button>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
